export default (value?: string) => {
    if (!value) {
        return undefined;
    }

    switch (value) {
        case "top":
        case "left":
        case "flex-start":
            return "flex-start";
        case "bottom":
        case "right":
        case "flex-end":
            return "flex-end";
        case "middle":
        case "center":
            return "center";
        default:
            return undefined;
    }
};
